import { hasWindow } from "@omni/utils/dom.utils";
import { attempt } from "@omni/utils/function.utils";
import queryString from "query-string";
import React, { ReactNode } from "react";

type ConditionalWrapperProps = {
    condition: boolean;
    wrapper: (children: any) => ReactNode;
    alternative?: (children: any) => ReactNode;
    children?: React.ReactNode;
};

export const ConditionalWrapper = ({
    condition,
    wrapper,
    children,
    alternative
}: ConditionalWrapperProps) => {
    return (
        <>
            {condition
                ? wrapper(children)
                : alternative
                  ? alternative(children)
                  : children}
        </>
    );
};

export const mapSeries = async <T, R>(
    iterable: Array<T>,
    action: (item: T) => Promise<R>
) => {
    const res: Array<R> = [];
    for (const x of iterable) {
        res.push(await action(x));
    }
    return res;
};

export const isAuthorEnvironment = () => {
    return hasWindow() && !!window?.Granite?.author;
};

export const getAlgoliaQuery = () => {
    return (
        attempt(
            () => queryString.parse(window.location.search).q as string,
            ""
        ) || ""
    );
};
